import { useMediaQuery, useTheme } from '@material-ui/core';
// Design System
import { DefaultCard } from 'design-system';
// funtions
// Components
import IndividualPriceDetail from 'src/components/screens/components/IndividualPriceDetail';
import BodyResumeCard from './BodyResumeCard';
import { CardIndividualProps } from './CardIndividual';

type Props = CardIndividualProps & {
  forceCollapsed?: boolean;
  onForceCollapsedUpdate?: () => void;
  openDialog?: boolean;
};

const IndividualUnitResumeCard = ({
  coverageCatalogResumes,
  coverageCatalogs,
  moneyType,
  packageOption,
  unit,
  forceCollapsed,
  onForceCollapsedUpdate,
  quotation,
  openDialog,
}: Props): JSX.Element => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <DefaultCard
      data-testid="individual-unit-resume-card"
      title=""
      nonCollapsibleElement={
        <IndividualPriceDetail
          data-testid="individual-price-detail"
          anualPrice={unit.total.grandTotal}
          moneyType={moneyType}
          packageOption={packageOption}
          openDialog={openDialog}
          isInspection={isMobile}
        />
      }
      collapsible={isMobile}
      forceCollapsed={forceCollapsed}
      onForceCollapsedUpdate={onForceCollapsedUpdate}
    >
      <BodyResumeCard
        coverageCatalogResumes={coverageCatalogResumes}
        coverageCatalogs={coverageCatalogs}
        moneyType={quotation.quotationProfile.typeOfMoney}
        packageOption={packageOption}
        unit={unit}
        quotation={quotation}
      />
    </DefaultCard>
  );
};

export default IndividualUnitResumeCard;
